import { ApolloCache, ApolloError, DefaultContext, MutationHookOptions, OperationVariables, useMutation } from '@apollo/client';
import { toastAlert } from '~/utils/toastify';
import { SIGN_UP_GQL } from './gql';

type MutationOptions = MutationHookOptions<any, OperationVariables, DefaultContext, ApolloCache<any>>;

const errorHandler = ({ message }: ApolloError) => toastAlert({ type: 'error', message });

export const useSignUp = (options: MutationOptions) => {
    return useMutation(SIGN_UP_GQL, {
        onError: errorHandler,
        ...options,
    })
}




